import { Map, fromJS } from 'immutable';

import type { TypedMap } from 'utils/typed-map';
import type { DeedActions } from 'entities/deed/actions';

import {
  ADD,
  ADD_MULTIPLE,
  UPDATE,
  UPDATE_DEED_PARTIALLY,
  REMOVE,
  UPCOMING_DEEDS_LOADED,
  PAST_DEEDS_LOADED,
} from './constants';
import Deed from './model';

export type DeedState = TypedMap<{
  deeds: Map<string, Deed>; // by deedId
  upcomingDeedsLoaded: Map<string, boolean>; // by userId
  pastDeedsLoaded: Map<string, boolean>; // by userId
}>;

const initialState: DeedState = fromJS({
  deeds: Map(),
  upcomingDeedsLoaded: Map(),
  pastDeedsLoaded: Map(),
});

export default (state = initialState, action: DeedActions | { type: 'RESET' }): DeedState => {
  switch (action.type) {
    case UPCOMING_DEEDS_LOADED:
      return state.set(
        'upcomingDeedsLoaded',
        state.get('upcomingDeedsLoaded').set(action.userId, true)
      );

    case PAST_DEEDS_LOADED:
      return state.set('pastDeedsLoaded', state.get('pastDeedsLoaded').set(action.userId, true));

    case ADD:
      return state.set('deeds', state.get('deeds').set(action.deed.id, action.deed));

    case ADD_MULTIPLE:
      return state.set('deeds', state.get('deeds').merge(action.deeds));

    case UPDATE:
      return state.set('deeds', state.get('deeds').set(action.deed.id, action.deed));

    case UPDATE_DEED_PARTIALLY:
      return state.updateIn(['deeds', action.deedFields.id], (existingDeed) =>
        existingDeed.merge(action.deedFields)
      );

    case REMOVE:
      return state.set('deeds', state.get('deeds').delete(action.id));

    case 'RESET':
      return initialState;

    default:
      return state;
  }
};
